"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteLinks = void 0;
const gearbox_1 = require("@busy-human/gearbox");
const firestore_1 = require("firebase/firestore");
var InviteLinks;
(function (InviteLinks) {
    function genericLocationForLink(link) {
        switch (link.location.type) {
            case 'video':
                return `Video Call`;
            case 'phone':
                return `Phone Call`;
            case 'physical':
                return "In-Person";
            case "other":
                return "Custom";
        }
    }
    InviteLinks.genericLocationForLink = genericLocationForLink;
    function DefaultCollector() {
        const tmp = Defaults();
        tmp.collector = '';
        return tmp;
    }
    InviteLinks.DefaultCollector = DefaultCollector;
    function DefaultPayer() {
        const tmp = Defaults();
        tmp.payer = '';
        tmp.paymentMethodPath = '';
        return tmp;
    }
    InviteLinks.DefaultPayer = DefaultPayer;
    function Defaults() {
        return {
            name: '',
            note: '',
            contactInfo: '',
            link: '',
            minutes: 30,
            price: { 'currency': '$', 'amount': 50, 'gross': 50 },
            uses: 0,
            active: true,
            checkoutId: null,
            location: null
        };
    }
    InviteLinks.Defaults = Defaults;
    function Validate(data) {
        const rawData = data;
        const fail = (reason) => {
            return { isValid: false, reason };
        };
        if (typeof rawData.startTime !== 'undefined' && typeof rawData.startTime !== 'string')
            return fail("startTime must be a string");
        if (typeof rawData.name !== 'string')
            return fail("Name must be a string");
        if (typeof rawData.note !== 'string')
            return fail("Note must be a string");
        if (typeof rawData.contactInfo !== 'string')
            return fail("Contact info must be a string");
        if (typeof rawData.link !== 'string')
            return fail("Link must be a string");
        if (typeof rawData.minutes !== 'number')
            return fail("Minutes must be a number");
        if (rawData.minutes < 0)
            return fail("Minutes must be positive");
        if (typeof rawData.price !== 'object')
            return fail("Price must be an object");
        if (typeof rawData.location !== 'object')
            return fail("Location must be an object of Location Data");
        if (typeof rawData.price.currency !== 'string' || rawData.price.currency !== '$')
            return fail("Currency must be a string");
        if (typeof rawData.price.amount !== 'number')
            return fail("Price Amount must be a number");
        if (typeof rawData.uses !== 'number')
            return fail("Uses must be a number");
        if (typeof rawData.active !== 'boolean')
            return fail("Active must be a boolean");
        if (typeof rawData.maxUses !== 'undefined' && typeof rawData.maxUses !== 'number')
            return fail("Max Uses must be a number");
        if (rawData.checkoutId !== null && typeof rawData.checkoutId !== 'string')
            return fail("checkoutId must be null or a string");
        if (typeof rawData.collector !== 'undefined' && typeof rawData.payer !== 'undefined')
            return fail("Invite must specify payer or collector, but not both");
        if (typeof rawData.collector !== 'undefined' && typeof rawData.collector !== 'string')
            return fail("Collector must be a string");
        if (typeof rawData.payer !== 'undefined' && typeof rawData.payer !== 'string')
            return fail('Payer must be a string');
        if (typeof rawData.paymentMethodPath !== 'undefined' && typeof rawData.paymentMethodPath !== 'string')
            return fail('paymentMethodPath must be a string');
        const tmp = {
            name: rawData.name,
            note: rawData.note,
            contactInfo: rawData.contactInfo,
            link: rawData.link,
            price: {
                amount: rawData.price.amount,
                gross: rawData.price.amount,
                currency: rawData.price.currency,
            },
            minutes: rawData.minutes,
            uses: rawData.uses,
            active: rawData.active,
            checkoutId: rawData.checkoutId,
            location: rawData.location
        };
        if (rawData.payer)
            tmp.payer = rawData.payer;
        if (rawData.collector)
            tmp.collector = rawData.collector;
        if (rawData.startTime)
            tmp.startTime = rawData.startTime;
        if (rawData.maxUses)
            tmp.maxUses = rawData.maxUses;
        if (rawData.paymentMethodPath)
            tmp.paymentMethodPath = rawData.paymentMethodPath;
        return { isValid: true, model: tmp };
    }
    InviteLinks.Validate = Validate;
    class CollectionClass extends gearbox_1.CollectionEntity {
        defaults() {
            return Defaults();
        }
        fetchInviteForLink(link) {
            return __awaiter(this, void 0, void 0, function* () {
                const tmp = yield this.fetchDocWithQuery(ref => (0, firestore_1.query)(ref, (0, firestore_1.where)("link", "==", link), (0, firestore_1.limit)(1)));
                return tmp ? tmp.data() : null;
            });
        }
        fetchUsersLinks(userId) {
            return __awaiter(this, void 0, void 0, function* () {
                const allLinks = [];
                const collectorDocs = yield this.subset(ref => (0, firestore_1.query)(ref, (0, firestore_1.where)("collector", "==", userId))).fetch();
                const payerDocs = yield this.subset(ref => (0, firestore_1.query)(ref, (0, firestore_1.where)("payer", "==", userId))).fetch();
                let allDocs = collectorDocs.concat(payerDocs);
                allDocs.forEach((doc) => {
                    allLinks.push(doc.data());
                });
                return allLinks;
            });
        }
    }
    InviteLinks.CollectionClass = CollectionClass;
    InviteLinks.Collection = new CollectionClass({ path: '/InviteLinks' });
})(InviteLinks = exports.InviteLinks || (exports.InviteLinks = {}));
exports.default = InviteLinks;
//# sourceMappingURL=index.js.map